module.exports = __webpack_public_path__ + "img/logo-login.92088d5a.png";